<template>
  <div class="iw-layout-grid__col--span-12 p-l-16">
    <back-button v-if="seatRequired" :route-to="{ name: ROUTE_NAMES.VENUE_CONTAINER }"> </back-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BackButton from "@/components/buttons/back-button/BackButton.vue";
import { ROUTE_NAMES } from "@/../app-constants";

export default {
  name: "SeatPageLink",
  components: { BackButton },
  data: function() {
    return {
      ROUTE_NAMES
    };
  },
  computed: {
    ...mapGetters({
      seatRequired: "venueSettings/seatRequired"
    })
  }
};
</script>
